export const menuServingTimeTranslationJP = {
  menuServingTime: {
    title: '提供タイミング一覧',
    button: {
      add: '新規追加',
      detail: '詳細',
      delete: '削除',
      restore: '復元',
    },
    table: {
      choice: '選択',
      name: '提供タイミング名',
      provision_pattern: {
        title: '提供パターン',
        before: '1：食前）',
        after: '2：食後）',
        together: '3：同時）',
      },
      note: '備考',
      status: 'デフォルト',
    },
    modal: {
      delete_default_on:
        'この提供タイミングを削除すると、メニューの提供タイミング設定がデフォルトに変更されます。よろしいですか？',
      delete_default_off:
        'この提供タイミングを削除すると、メニューの提供タイミング設定が現在のデフォルトに変更されます。よろしいですか？',
      delete_success: 'データを削除しました',
      at_least_one: '提供タイミングは最低1件残す必要があります。最後の1件は削除できません。',
      status_at_least_one: '必ず 1件のみ「デフォルト」ON が設定されている状態にしておく。',
      restore: '提供タイミングを復元しました。メニューに設定された提供タイミングは変更されません。',
      update_status: 'デフォルトを更新しました',
    },
  },
  menuServingTimeDetail: {
    subject: '提供タイミング詳細',
    button: {
      save: '保存',
    },
    name: '名称',
    title: 'タイトル',
    title_ja: '日本語',
    title_en: '英語',
    title_zh_hans: '中国語（簡体字）',
    title_zh_hant: '中国語（繁体字）',
    title_ko: '韓国語',
    title_vi: 'ベトナム語',
    before: ' 1：食前）',
    after: '2：食後）',
    together: '3：同時）',
    enable_disable: '有効／無効',
    message: 'メッセージ',
    provision_pattern: '提供パターン',
    image: '画像',
    note: '備考',
    warn_field_required: 'この項目は必須です',
    provision_pattern_at_least_one: '少なくとも 1 つの提供パターンを有効にする必要があります。',
    sucesss_save: '保存しました',
  },
};
